/*
 * @Author: 肖玲
 * @Date: 2023-02-28 16:19:01
 * @LastEditTime: 2023-02-28 16:26:48
 * @LastEditors: 肖玲
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\router\butterfly-flow-system\flow-direction-import\index.js
 * 流向导入路由
 */
import flowDirectionImportRouter from "./modules/flowDirectionImportRouter";
import noCleanflowDirectionRouter from "./modules/noCleanflowDirectionRouter";
import uploadRecordRouter from "./modules/uploadRecordRouter";

const flowDirectionImportRouters = [].concat(
  flowDirectionImportRouter,
  noCleanflowDirectionRouter,
  uploadRecordRouter,
)

export default flowDirectionImportRouters